<template>
  <v-dialog class="pl-dialog" :max-width="500" persistent v-model="viewDialog">
    <v-card>
      <v-card-title class="pl-dialog__title">
        <h4>{{ title }}</h4>
      </v-card-title>
      <v-card-text :class="{ 'text-sm-center': msgTextCenter }">
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-layout justify-end>
          <v-btn @click="cancelDelete"> Отмена </v-btn>

          <v-btn color="primary" @click="deleteEntity"> OK </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteDialog',
  props: {
    title: {
      type: String,
      default: 'Удаление',
    },
    message: {
      type: String,
      default: '',
    },
    viewDialog: {
      type: Boolean,
      default: false,
    },
    msgTextCenter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    deleteEntity(event) {
      this.$emit('deleteEntity', event)
    },
    cancelDelete(event) {
      this.$emit('cancelDelete', event)
    },
  },
}
</script>
